module.exports = __webpack_public_path__ + "img/sec-2-click.81bd25a6.png";